export const FeatureDataFragment = `
    id
    label
    feature_key
    category
    is_active
    is_limitable
    is_toggleable
`
